var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSwap = function SvgIconSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_swap_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_swap_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "m4.875 13.25 1.667 1.667a.733.733 0 0 1 0 1.062.733.733 0 0 1-1.063 0l-2.958-2.958a.756.756 0 0 1-.208-.525c0-.1.017-.194.052-.281a.69.69 0 0 1 .156-.236l2.958-2.958a.73.73 0 0 1 .531-.23c.202 0 .382.077.542.23a.745.745 0 0 1-.01 1.062L4.875 11.75h5.375c.213 0 .39.071.534.214a.72.72 0 0 1 .216.532c0 .21-.072.39-.216.535a.72.72 0 0 1-.534.219H4.875Zm10.25-5H9.75a.728.728 0 0 1-.534-.214A.72.72 0 0 1 9 7.504c0-.21.072-.39.216-.535a.72.72 0 0 1 .534-.219h5.375l-1.667-1.667a.733.733 0 0 1 0-1.062.733.733 0 0 1 1.063 0l2.958 2.958a.756.756 0 0 1 .208.525c0 .1-.017.194-.052.281a.691.691 0 0 1-.156.236l-2.958 2.958a.663.663 0 0 1-.517.219.797.797 0 0 1-.535-.24.745.745 0 0 1 .01-1.062l1.646-1.646Z"
  }))));
};
export default SvgIconSwap;